import { motion } from "framer-motion";
import { BadgePercent, Banknote, Landmark, Truck } from "lucide-react";

const POLICIES = [
  {
    icon: BadgePercent, color: "bg-kyellow", testid: "policy-card-deposit",
    title: "Seña del 50%",
    text: "Para apartar o personalizar tu pedido pedimos una seña del 50% del total. Así reservamos tu producto al instante.",
  },
  {
    icon: Banknote, color: "bg-kpink text-white", testid: "policy-card-payment",
    title: "Pago total al retirar",
    text: "Antes de salir del local o de despachar tu pedido, el producto debe abonarse en su totalidad.",
  },
  {
    icon: Landmark, color: "bg-kcyan", testid: "policy-card-transfer",
    title: "Transferencias bancarias",
    text: "Aceptamos transferencias bancarias y efectivo para tu comodidad. Te pasamos los datos por WhatsApp.",
  },
  {
    icon: Truck, color: "bg-kpurple text-white", testid: "policy-card-shipping",
    title: "Envíos a todo el país",
    text: "Realizamos envíos a todo Paraguay. El costo del envío es adicional y depende del destino.",
  },
];

export default function Policies() {
  return (
    <section id="como-comprar" className="py-20 lg:py-28 bg-ink text-paper border-b-2 border-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }}>
          <span className="font-mono text-xs uppercase tracking-[0.2em] font-bold text-kyellow">Cómo comprar</span>
          <h2 className="font-display font-extrabold tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-2">
            Simple, claro y sin vueltas
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 mt-12">
          {POLICIES.map((p, i) => (
            <motion.div key={p.testid}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={p.testid}
              className="bg-paper text-ink border-2 border-paper/0 rounded-3xl p-7 shadow-[6px_6px_0px_#FFD027] hover:-translate-y-1.5 transition-transform duration-300">
              <div className={`h-13 w-13 inline-grid place-items-center rounded-2xl border-2 border-ink p-3 ${p.color}`}>
                <p.icon size={24} strokeWidth={2.5} />
              </div>
              <h3 className="font-display font-bold text-xl mt-4">{p.title}</h3>
              <p className="text-ink/70 mt-2 font-medium leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
